// extracted by mini-css-extract-plugin
module.exports = {"annal":"Annals_annal__snHuu","text":"Annals_text__1ehj6"};